<template lang="html">
  <v-container fluid v-if="template">
   
    <v-divider></v-divider>
    <v-layout>
      <v-flex xs12 md6>
        <v-textarea
          label="Greeting"
          v-model="template.greeting"
          @input="updateTemplate()"
        ></v-textarea>
        <v-textarea
          label="Content 1"
          v-model="template.content1"
          auto-grow
          @input="updateTemplate()"
        ></v-textarea>
        <v-textarea
          label="Content 2"
          v-model="template.content2"
          auto-grow
          @input="updateTemplate()"
        ></v-textarea>
        <v-textarea
          label="Signature"
          v-model="template.firm"
          auto-grow
          @input="updateTemplate()"
        ></v-textarea>
        <v-textarea
          label="Footer"
          v-model="template.footer"
          auto-grow
          @input="updateTemplate()"
        ></v-textarea>
      </v-flex>
      <v-flex xs12 md6>
        <div class="fluid" v-html="preview"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import lodash from 'lodash';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    templateId: {
      type: String,
      required: true,
    },
    roundId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      template: null,
      preview: null,
      loader: 0
    };
  },
  computed: {
   
  },
  watch: {
    templateId () {
      this.getTemplate();
    }
  },
  mounted () {
    this.getTemplate();
  },
  created () {
    this.updateTemplate = lodash.debounce(this.updateTemplate, 1000);
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    getTemplate () {
      const url = `templates/${this.templateId}/edit`;
      window.axios.get(url).then(response => {
        this.template = response.data.data;
        this.previewTemplate();
      }).catch(error => {
        this.setSnackbar({
          show: true,
          color: 'red',
          text: 'Template Updated Error!'
        });
      });
    },
    updateTemplate () {
      const url = `templates/${this.template.id}`;
      const payload = {
        id: this.template.id,
        greeting: this.template.greeting,
        content1: this.template.content1,
        content2: this.template.content2,
        firm: this.template.firm,
        footer: this.template.footer,
        type: this.type
      };
      if (!this.template.default) {
        window.axios.put(url, payload).then(response => {
          this.setSnackbar({
            show: true,
            color: 'green',
            text: 'Template Updated!'
          });
          this.previewTemplate();
        }).catch(error => {
          this.setSnackbar({
            show: true,
            color: 'red',
            text: 'Template Updated Error!'
          });
        });
      } else {
        this.$emit('open-modal-create-template');
      }
      
    },
    previewTemplate () {
      /* Fix Change template, not found */
      const url = `templates/${this.template.type}/preview/round/${this.roundId}`;
      window.axios.get(url).then(response => {
        this.preview = response.data;
      }).catch(error => {
        this.setSnackbar({
          show: true,
          color: 'red',
          text: 'Template Updated Error!'
        });
      });
    }
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/templates/Show.vue